import { useEffect, useState } from 'react'
import { Description } from '@mui/icons-material'
import { Button, Stack, Typography } from '@mui/material'
import useOverlay from '@/hooks/useOverlay'
import {
  useGetDocumentsCount,
  useGetDocumentsExist,
} from '@/service-library/hooks/documents'
import ExpandAndGrow from '../expand-and-grow/ExpandAndGrow'
import OutlinedCard from '../outlined-card/OutlinedCard'
import OrphanedDocumentsDialog, {
  orphanedDocumentFilters,
} from './OrphanedDocumentsDialog'

export default function OrphanedDocumentsCard() {
  const overlay = useOverlay()
  const [shouldCheckExists, setShouldCheckExists] = useState(true)
  const [shouldRefetchCount, setShouldRefetchCount] = useState(false)

  const { exists } = useGetDocumentsExist({
    filters: orphanedDocumentFilters,
    // Every 60 seconds since we don't need real-time updates
    refetchInterval: 60000, // Temporary until we have notifications
    enabled: shouldCheckExists,
  })
  const { documentsCount } = useGetDocumentsCount({
    filters: orphanedDocumentFilters,
    refetchInterval: shouldRefetchCount ? 2000 : false,
    enabled: exists,
  })

  // While we know there are documents being auto-assigned, no need to check for existence
  useEffect(() => {
    setShouldCheckExists(documentsCount === 0)
  }, [documentsCount])

  return (
    <ExpandAndGrow show={exists && documentsCount > 0} expandedHeight={48}>
      <OutlinedCard>
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          justifyContent="space-between"
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <Description fontSize="small" />
            <Typography variant="body2" color="text.secondary">
              {documentsCount} document{documentsCount !== 1 ? 's' : ''} not
              assigned to a project
            </Typography>
          </Stack>
          <Button variant="text" size="small" onClick={overlay.open}>
            View
          </Button>
        </Stack>

        <OrphanedDocumentsDialog
          overlay={overlay}
          setShouldRefetchCount={setShouldRefetchCount}
        />
      </OutlinedCard>
    </ExpandAndGrow>
  )
}
